import { apiClient } from '@/services/api';
import { StorageKeys, getItem, setItem } from '@/services/storage';

const state = () => ({
    producoes: null,
    selectedProducao: null,
    automaticUpdateOfColabs: 1,
    credenciaisYoutube: null,
    enqueteQrCode: false,
    qrCodeCombined: false,
    tarjaMode: false
});

const getters = {
    getterProducoes: state => {
        return state.producoes;
    },
    getterProducao: state => {
        return state.selectedProducao
    },
    getterColabsUpdateMode: state => {
        return state.automaticUpdateOfColabs;
    },
    getterProducaoCredenciaisYoutube: state => {
        return state.credenciaisYoutube;
    },
    getterSettings: state => {
        return state.selectedProducao?.settings || {};
    },
    getterDarkMode: state => {
        return state.selectedProducao?.dsc_hex_background_card_noticias === true || false;
    },
    getterQRCodeMode: state => {
        return state.selectedProducao?.settings?.enquete?.qr_code ?? false;
    },
    getterQRCodeCombinedMode: state => {
        return state.selectedProducao?.settings?.enquete?.qr_code_combined ?? false;
    },
    getterTarjaMode: state => {
        return state.selectedProducao?.settings?.enquete?.tarja_mode ?? false;
    },
};

const actions = {
    async getProducoes({ commit }, payload) {
        const { page, size, dsc_excecao, flg_ativo, dsc_login_usuario, isAdmin } = payload;
        try {
            const params = new URLSearchParams({
                page: page ?? '',
                size: size ?? 500,
                filtro_texto: dsc_excecao ?? '',
                flg_ativo: flg_ativo ?? '',
                dsc_login_usuario: dsc_login_usuario ?? '',
                isAdmin: isAdmin ?? false,
                _: Date.now(),
            });
            const { data } = await apiClient.get(`/listarDadosProducoes/?${params.toString()}`);
            commit('setProducoes', data.producoes);
        } catch (error) {
            return error;
        }
    },

    async getProducaoCredenciaisYoutube({ commit }, cod_producao) {
        try {
           const { data } = await apiClient.get(`youtube/list/${cod_producao}`);
           commit('setCredenciaisYoutube', data.credencial)
        } catch (error) {
            return error
        }
      },

    async setSelectedProducao({ commit }, value) {
        try {
            commit("setSelectedProducao", value)
        } catch (error) {
            return error
        }
    },

    async initFromStorage({ state, commit, dispatch, rootState }) {
        const codProducao = Number(getItem(StorageKeys.SELECTED_PRODUCTION));
        if (!codProducao || state.selectedProducao?.cod_producao === codProducao) return;

        // `state.producoes` is the { totalItems, ..., items } wrapper — `.find()` on the
        // wrapper itself returns undefined and silently skips the selection.
        if (state.producoes?.items?.length) {
            const producao = state.producoes.items.find(p => p.cod_producao === codProducao);
            if (producao) {
                commit('setSelectedProducao', producao);
                return;
            }
        }

        // Through getProducoes so this path is scoped like the others: it used to build the
        // URL by hand with isAdmin=true and no user, seeding the store unscoped on startup.
        try {
            await dispatch('getProducoes', {
                page: 1,
                flg_ativo: 'S',
                dsc_login_usuario: rootState.users.user?.dsc_login_usuario,
                isAdmin: rootState.users.user?.dsc_perfil === 'ADMINISTRADOR',
            });

            const producao = state.producoes?.items?.find(p => p.cod_producao === codProducao);
            if (producao) {
                commit('setSelectedProducao', producao);
            }
        } catch (error) {
            return error;
        }
    },

    setColabsUpdateMode({ commit }, value) {
        try {
            commit("setColabsUpdateMode", value);
        } catch (error) {
            console.error(error);
            return error
        }
    },

    async updateDarkMode({ commit }, { cod_producao, flg_dark_mode }) {
        try {
            const { data } = await apiClient.patch("/updateCorBackgroundChromaNoticias", {
                cod_producao: cod_producao,
                flg_dark_mode: flg_dark_mode
            });

            commit('updateSelectedProducao', {
                dsc_hex_background_card_noticias: flg_dark_mode,
                ...(data.colors && data.colors.background && {
                    dsc_hex_background_chroma_noticias: data.colors.background
                })
            });

            return { success: true, message: data.msg };
        } catch (error) {
            console.error('Error updating dark mode:', error);
            return error;
        }
    },

    setQRCodeMode({ commit }, payload) {
        if (typeof payload === 'boolean') {
            commit('setQRCodeMode', payload);
            commit('setQRCodeCombinedMode', false);
            commit('setTarjaMode', false);
        } else if (typeof payload === 'object') {
            commit('setQRCodeMode', payload.enabled || false);
            commit('setQRCodeCombinedMode', payload.combined || false);
            if (payload.tarjaMode !== undefined) {
                commit('setTarjaMode', payload.tarjaMode);
            }
        }
    }
}

const mutations = {
    setProducoes(state, payload) {
        state.producoes = payload;
    },
    setSelectedProducao(state, value) {
        state.selectedProducao = value;
        if (value && value.cod_producao) {
            setItem(StorageKeys.SELECTED_PRODUCTION, value.cod_producao);
        }
    },
    setColabsUpdateMode(state, value) {
        state.automaticUpdateOfColabs = value;
    },
    setCredenciaisYoutube(state, payload) {
        state.credenciaisYoutube = payload
    },
    updateSelectedProducao(state, payload) {
        state.selectedProducao = {
            ...state.selectedProducao,
            ...payload
        };
    },
    setQRCodeMode(state, value) {
        state.enqueteQrCode = value;
    },
    setQRCodeCombinedMode(state, value) {
        state.qrCodeCombined = value;
    },
    setTarjaMode(state, value) {
        state.tarjaMode = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
